import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';

import moment from "moment"
import 'moment/locale/fr';

import { FirebaseProvider } from './services/Firebase'
import { AuthProvider } from './services/Session'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import PrivateRoute from './components/PrivateRoute';
import AutoLogin from './components/AutoLogin';
import NotFound from './pages/NotFound';
import UserProfile from './pages/UserProfile';
import Training from './pages/Training';
import TrainingCreate from './pages/TrainingCreate'
import ModuleCreate from './pages/ModuleCreate'
import TrainingDetails from './pages/TrainingDetails'
import TrainingModuleScenario from './pages/TrainingModuleScenario'
import ActivityDetails from './pages/ActivityDetails'
import { TrainingContext } from './services/Training'
import DocumentViewer from './pages/DocumentViewer';



moment.locale('fr')

function App() {
  const [trainingContext, setTrainingContext] = useState(null)

  return (
    <FirebaseProvider>
      <AuthProvider>
        <TrainingContext.Provider value={[trainingContext, setTrainingContext]}>
          <Router>
            <Routes>
              <Route
                path="/login"
                element={<AutoLogin component={<Login/>} />}
              />
              <Route
                path="/profile"
                element={<PrivateRoute component={<UserProfile/>} />}
              />
              <Route
                path="/training/:id/modules/new"
                element={<PrivateRoute component={<ModuleCreate/>} />}
              />
              <Route
                path="/training/:id/modules/:moduleId/activities/:activityId"
                element={<PrivateRoute component={<ActivityDetails/>} />}
              />
              <Route
                path="/training/:id/modules/:moduleId/modify"
                element={<PrivateRoute component={<ModuleCreate/>} />}
              />
              <Route
                path="/training/:id/modules/:moduleId"
                element={<PrivateRoute component={<TrainingModuleScenario/>} />}
              />
               <Route
                path="/training/:id/documents/script"
                element={<PrivateRoute component={<DocumentViewer/>} />}
              />
              <Route
                path="/training/new"
                element={<PrivateRoute component={<TrainingCreate/>} />}
              />
              <Route
                path="/training/:id"
                element={<PrivateRoute component={<TrainingDetails/>} />}
              />
              <Route
                path="/training"
                element={<PrivateRoute component={<Training/>} />}
              />
              <Route
                path="/"
                element={<PrivateRoute component={<Dashboard/>} />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
          <Toaster />
        </TrainingContext.Provider>
      </AuthProvider>
    </FirebaseProvider>
  );
}

export default App;
